import React, { Profiler } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Login from './pages/login';
import Register from './pages/register';
import Home from './pages/home';
import AddMoney from './pages/add-money';
import PaymentConfirmation from './pages/payment-confirmation';
import ProfileEdit from './pages/profile-edit';
import SupportCenter from './pages/support-center';
import History from './pages/history';
import Margin from './pages/margin';
import ProfileDetails from './pages/profile';
import ReferCode from './pages/refer-code';
import TransactionDetail from './pages/transaction-details';
import Notification from './pages/notification';
import PaymentStatus from './pages/payment-status';
import KycVerification from './pages/kyc-verification';
import { apiCall } from './utils/api';
import Services from './pages/services';
import Apdcl from './pages/additional/apdcl';
import AgentCommission from './pages/agent/commission';
import AgentDashboard from './pages/agent/dashboard';
import AgentRetailer from './pages/agent/retailer';
import SessionLogin from './pages/session-login';

window.addEventListener("message", async (event) => {
  try {
    // Check if event.data is a string or object
    let data;
    if (typeof event.data === 'string') {
      data = JSON.parse(event.data);
    } else {
      // If it's already an object, use it directly
      data = event.data;
    }

    if (data.type === "DEVICE_INFO") {
      const storedUserData = localStorage.getItem("credentials");
      const parsedData = storedUserData ? JSON.parse(storedUserData) : null;

      const payload = {
        user_id: parsedData?.user_id || null,
        token: parsedData?.login_token || null,
        device_token: data?.token || null,
        device_id: data?.device_id || null,
        platform: data?.platform || null
      };

      try {
        const result = await apiCall("save-notification-token", payload, false);
        if (result.status === true) {
          console.log("Notification token saved successfully!");
        } else {
          console.error("Failed to save notification token:", result.message);
        }
      } catch (error) {
        console.error("Network error:", error);
      }
    }
  } catch (e) {
    console.error("Error in message listener:", e);
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Navigate to="/home" replace />} />
      <Route path="/session-login" element={<SessionLogin />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/home" element={<Home />} />
      <Route path="/services" element={<Services />} />
      <Route path="/add-money" element={<AddMoney />} />
      <Route path="/history" element={<History />} />
      <Route path="/margin" element={<Margin />} />
      <Route path="/kyc-verification" element={<KycVerification />} />
      <Route path="/notification" element={<Notification />} />
      <Route path="/payment-confirmation" element={<PaymentConfirmation />} />
      <Route path="/profile-edit" element={<ProfileEdit />} />
      <Route path="/support-center" element={<SupportCenter />} />
      <Route path="/profile" element={<ProfileDetails />} />
      <Route path="/refer-code" element={<ReferCode />} />
      <Route path="/transaction-detail" element={<TransactionDetail />} />
      <Route path="/payment-status" element={<PaymentStatus />} />
      <Route path="/additional/apdcl" element={<Apdcl />} />
      <Route path="/agent/dashboard" element={<AgentDashboard />} />
      <Route path="/agent/commission" element={<AgentCommission />} />
      <Route path="/agent/retailer" element={<AgentRetailer />} />
    </Routes>
  </BrowserRouter>
);
reportWebVitals();
